import { Phone } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { ContactChooser, WaIcon } from "@/components/site/ContactChooser";

export default function StickyCTA() {
  const { t } = useApp();
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-slate-200 bg-white"
    >
      <ContactChooser type="tel" side="top">
        <button
          data-testid="sticky-call"
          className="flex items-center justify-center gap-2 py-4 font-semibold text-brand active:bg-slate-100"
          aria-label={t.contact.call}
        >
          <Phone size={20} /> {t.contact.call}
        </button>
      </ContactChooser>
      <ContactChooser type="wa" side="top">
        <button
          data-testid="sticky-whatsapp"
          className="flex items-center justify-center gap-2 py-4 font-semibold text-white bg-wa active:brightness-95"
          aria-label={t.contact.whatsapp}
        >
          <WaIcon /> WhatsApp
        </button>
      </ContactChooser>
    </div>
  );
}
